var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08464 1.74967V0.583008H5.2513V1.74967H8.7513V0.583008H9.91797V1.74967H12.2513C12.5735 1.74967 12.8346 2.01084 12.8346 2.33301V5.24967H11.668V2.91634H9.91797V4.08301H8.7513V2.91634H5.2513V4.08301H4.08464V2.91634H2.33464V11.083H5.83464V12.2497H1.7513C1.42914 12.2497 1.16797 11.9885 1.16797 11.6663V2.33301C1.16797 2.01084 1.42914 1.74967 1.7513 1.74967H4.08464ZM9.91797 6.99967C8.62933 6.99967 7.58464 8.04437 7.58464 9.33301C7.58464 10.6216 8.62933 11.6663 9.91797 11.6663C11.2066 11.6663 12.2513 10.6216 12.2513 9.33301C12.2513 8.04437 11.2066 6.99967 9.91797 6.99967ZM6.41797 9.33301C6.41797 7.40002 7.98498 5.83301 9.91797 5.83301C11.851 5.83301 13.418 7.40002 13.418 9.33301C13.418 11.266 11.851 12.833 9.91797 12.833C7.98498 12.833 6.41797 11.266 6.41797 9.33301ZM9.33463 7.58301V9.57462L10.6722 10.9121L11.4971 10.0872L10.5013 9.09139V7.58301H9.33463Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostTimeline);
export default __webpack_public_path__ + "static/media/post-timeline.4a4672fbbfae83f46cb1721dca7f8f75.svg";
export { ForwardRef as ReactComponent };